module.exports = __webpack_public_path__ + "img/bush.ca9bcd6.png";